<!--
Author: TangChen
Date: 2018-11-19
Desc: 适当性信息组件，由index.js 配置引入
-->
<template>
    <div class="comp-inv-info comp">
        <el-row class="acct-box two-cols-form">
            <el-form
                ref="acctInfo"
                :model="acctInfo"
                :rules="rules"
                label-width="140px"
                class="acct-form"
                size="small"
                v-on:submit.native.prevent
            >
                <el-col :span="12">
                    <el-form-item label="机构名称：" class="form-text">
                        <div class="text-con">
                            {{ acctInfo.custfullname }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资者类型：" class="form-text">
                        <div class="text-con">
                            {{ $cache.getDict('120051', acctInfo.professionflag) }}
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="企业性质：" prop="enterprisenature" class="required">
                        <el-select
                            v-model="acctInfo.enterprisenature"
                            filterable
                            placeholder="请选择企业性质"
                        >
                            <el-option
                                v-for="item in $cache.getDict('120076')"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="注册资本(元)：" prop="registeredcapital" class="required">
                        <el-input v-model.trim="acctInfo.registeredcapital" placeholder="请输入注册资本" :maxlength="18" />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资资金来源：" prop="incomesource" class="required">
                        <el-select
                            v-model="acctInfo.incomesource"
                            filterable
                            placeholder="请选择投资资金来源"
                            :disabled="riskLock.indexOf('incomesource')>-1?true:false"
                        >
                            <el-option
                                v-for="item in incomesources"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="资产：" prop="assets" class="required">
                        <el-select
                            v-model="acctInfo.assets"
                            filterable
                            placeholder="请选择资产"
                            :disabled="riskLock.indexOf('assets')>-1?true:false"
                        >
                            <el-option
                                v-for="item in annualincomes"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="负债：" prop="debt" class="required">
                        <el-select
                            v-model="acctInfo.debt"
                            filterable
                            placeholder="请选择负债"
                            :disabled="riskLock.indexOf('debt')>-1?true:false"
                        >
                            <el-option
                                v-for="item in debts"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="年收入(元)：" prop="annualincome" class="required">
                        <!--<el-input
                            v-model.trim="acctInfo.annualincome"
                            placeholder="请选择年收入"
                            :maxlength="18"
                            :disabled="riskLock.indexOf('annualincome')>-1?true:false"
                        />-->
                        <el-select
                            v-model.trim="acctInfo.annualincome"
                            filterable
                            placeholder="请选择年收入"
                            :disabled="riskLock.indexOf('annualincome')>-1?true:false"
                        >
                            <el-option
                                v-for="item in annualincomes"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <!--<el-col :span="24">-->
                    <!--<el-form-item label="实际控制人：" prop="actualctrlname" class="required">-->
                        <!--<el-radio-group v-model="acctInfo.actualctrlname">-->
                            <!--<el-radio-->
                                <!--label="本机构"-->
                            <!--/>-->
                            <!--<el-radio-->
                                <!--label="其他"-->
                            <!--/>-->
                            <!--<el-input-->
                                <!--v-if="acctInfo.actualctrlname=='其他'"-->
                                <!--v-model.trim="acctInfo.actualctrlnameText"-->
                                <!--style="width:120px"-->
                                <!--placeholder=""-->
                                <!--:maxlength="16"-->
                            <!--/>-->
                        <!--</el-radio-group>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
                <!--<el-col :span="24">-->
                    <!--<el-form-item label="实际受益人：" prop="beneficiary" class="required">-->
                        <!--<el-radio-group v-model="acctInfo.beneficiary">-->
                            <!--<el-radio-->
                                <!--label="本机构"-->
                            <!--/>-->
                            <!--<el-radio-->
                                <!--label="其他"-->
                            <!--/>-->
                            <!--<el-input-->
                                <!--v-if="acctInfo.beneficiary=='其他'"-->
                                <!--v-model.trim="acctInfo.beneficiaryText"-->
                                <!--style="width:120px"-->
                                <!--placeholder=""-->
                                <!--:maxlength="16"-->
                            <!--/>-->
                        <!--</el-radio-group>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
                <el-col :span="12">
                    <el-form-item label="投资学习经历：" prop="investmentedu" class="required">
                        <el-select
                            v-model="acctInfo.investmentedu"
                            filterable
                            placeholder="请选择投资学习经历"
                            :disabled="riskLock.indexOf('investmentedu')>-1?true:false"
                        >
                            <el-option
                                v-for="item in investmentedus"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资工作经历：" prop="investmentwork" class="required">
                        <el-select
                            v-model="acctInfo.investmentwork"
                            filterable
                            placeholder="请选择投资工作经历"
                            :disabled="riskLock.indexOf('investmentwork')>-1?true:false"
                        >
                            <el-option
                                v-for="item in investmentworks"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资相关经验：" prop="investmentexp" class="required">
                        <el-select
                            v-model="acctInfo.investmentexp"
                            filterable
                            placeholder="请选择投资相关经验"
                            :disabled="riskLock.indexOf('investmentexp')>-1?true:false"
                        >
                            <el-option
                                v-for="item in investmentexps"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="投资期限：" prop="investmentterm" class="required">
                        <el-select
                            v-model="acctInfo.investmentterm"
                            filterable
                            placeholder="请选择投资期限"
                            :disabled="riskLock.indexOf('investmentterm')>-1?true:false"
                        >
                            <el-option
                                v-for="item in investmentterms"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="预期收益：" prop="execeptedearning" class="required">
                        <el-select
                            v-model="acctInfo.execeptedearning"
                            filterable
                            placeholder="请选择预期收益"
                            :disabled="riskLock.indexOf('execeptedearning')>-1?true:false"
                        >
                            <el-option
                                v-for="item in exceptedearnings"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="可承受损失：" prop="affordableloss" class="required">
                        <el-select
                            v-model="acctInfo.affordableloss"
                            filterable
                            placeholder="请选择可承受损失"
                            :disabled="riskLock.indexOf('affordableloss')>-1?true:false"
                        >
                            <el-option
                                v-for="item in affordableloss"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="诚信记录是否良好：" prop="cerditrecord" class="required">
                        <div class="person-sel">
                            <el-radio-group
                                v-model="acctInfo.cerditrecord"
                                :disabled="riskLock.indexOf('cerditrecord')>-1?true:false"
                            >
                                <el-radio
                                    v-for="item in cerditrecord"
                                    :key="item.id"
                                    :label="item.id"
                                    :value="item.id"
                                >
                                    {{ item.name }}
                                </el-radio>
                            </el-radio-group>
                            <el-input
                                v-if="acctInfo.cerditrecord!=='1'"
                                v-model.trim="acctInfo.creditText"
                                placeholder="请说明具体情况"
                                :maxlength="64"
                            />
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="投资品种：" prop="investfundtypeArr">
                        <el-checkbox-group
                            v-model="acctInfo.investfundtypeArr"
                            class="checkbox-list"
                            :disabled="riskLock.indexOf('investfundtype')>-1?true:false"
                        >
                            <el-checkbox v-for="item in investfundtypes" :key="item.subitem" :label="item.subitem">
                                {{ item.subitemname }}
                            </el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <country-city-select ref="usefullife" :isSync="true" v-model="usefullifeObj" country-layout="user" v-on:input="getUsefullife"></country-city-select>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="详细注册地址：" prop="usefullife" class="required">
                        <el-input v-model.trim="acctInfo.usefullife" placeholder="" :maxlength="64" />
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="经营范围：" prop="scopeofbusiness" class="required">
                        <el-input
                            v-model.trim="acctInfo.scopeofbusiness"
                            type="textarea"
                            placeholder="请输入经营范围"
                            :maxlength="128"
                        />
                    </el-form-item>
                </el-col>

                <el-col v-if="isPwdCheck" :span="12">
                    <el-form-item label="交易密码：" prop="pwd" class="required">
                        <el-input
                            v-model="acctInfo.pwd"
                            type="password"
                            placeholder="请输入交易密码"
                            :maxlength="16"
                        />
                    </el-form-item>
                </el-col>
                <el-col :span="24" class="btn-group">
                    <el-button type="yellow" class="medium" v-on:click="submitInfo('acctInfo')">
                        提交
                    </el-button>
                    <el-button class="medium" v-on:click="$router.back()">
                        返回
                    </el-button>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
    import format from "date-fns/format";
    //import datePicker from "@/components/common/datePicker.vue";
    import countryCitySelect from "@/components/acctInfo/countryCitySelect.vue";
    export default {
        name: "NavInvInfo",
        components: {
            //datePicker
            countryCitySelect
        },
        props: {
            fn: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                acctInfo: {
                    creditText:"",
                    investfundtypeArr: ""
                },
                checkacctInfo: {},
                isPwdCheck: false,
                birthSet: { type: "1", min: "", dis: false },
                cerditrecord: [{id: "1", name: "良好"}, {id: "2", name: "一般"}],
                person: [{ id: "1", name: "本机构" }, { id: "2", name: "非本机构" }],
                annualincomes: [],
                incomesources: [],
                debts: [],
                investmentedus: [],
                investmentworks: [],
                investmentexps: [],
                investmentterms: [],
                investfundtypes: [],
                exceptedearnings: [],
                affordableloss: [],
                usefullifeObj: {
                    country: "CN",
                    province: null,
                    city: null,
                    county: null,
                    address: null
                },
                riskLock: "",
                required: false,
                query: null,
                rules: {
                    registeredcapital: [
                        { required: true, message: "请输入注册资本", trigger: "change" }
                    ],
                    enterprisenature: [
                        { required: true, message: "请选择企业性质", trigger: "change" }
                    ],
                    actualctrlname: [
                        { validator:this.actNameRequired, message: "请输入实际控制人", trigger: "change" }
                    ],
                    beneficiary: [
                        { validator:this.benNameRequired, message: "请输入实际受益人", trigger: "change" }
                    ],
                    assets: [
                        { required: true, message: "请输入资产", trigger: "blur" }
                    ],
                    annualincome: [
                        { required: true, message: "请输入年收入", trigger: "blur" }
                    ],
                    incomesource: [
                        { required: true, message: "请选择投资资金来源", trigger: "change" }
                    ],
                    debt: [
                        { required: true, message: "请选择负债", trigger: "change" }
                    ],
                    investmentedu: [
                        { required: true, message: "请选择投资学习经历", trigger: "change" }
                    ],
                    investmentwork: [
                        { required: true, message: "请选择投资工作经历", trigger: "change" }
                    ],
                    investmentexp: [
                        { required: true, message: "请选择投资相关经验", trigger: "change" }
                    ],
                    investmentterm: [
                        { required: true, message: "请选择投资期限", trigger: "change" }
                    ],
                    execeptedearning: [
                        { required: true, message: "请选择预期收益", trigger: "change" }
                    ],
                    affordableloss: [
                        { required: true, message: "请选择可承受损失", trigger: "change" }
                    ],
                    cerditrecord: [
                        { validator: this.paramRequired, mes: "诚信记录", trigger: "change" }
                    ],
                    investfundtypeArr: [
                        { validator: this.selRequired, mes: "投资品种", trigger: "change" }
                    ],
                    usefullife: [
                        { required: true, message: "请输入注册地址", trigger: "blur" }
                    ],
                    scopeofbusiness: [
                        { required: true, message: "请输入经营范围", trigger: "blur" }
                    ],
                    pwd: [
                        { required: true, message: "请输入交易密码", trigger: "blur" }
                    ]
                }
            };
        },
        watch: {
            "acctInfo.cerditrecord"(val) {
                if (val === '1') {
                    this.acctInfo.creditText = ""
                }
            },
            "acctInfo.registeredcapital"(val) {
                this.mustNum(val, "registeredcapital");
            },
            "acctInfo.annualincome"(val) {
                this.mustNum(val, "annualincome");
            }
        },
        created () {
            const birthmax = this.$util.getBeginDate(format(new Date(), "YYYYMMDD"), 18, true);
            this.birthSet.max = this.$util.fmtDate(birthmax);
            this.birthSet.min = this.$util.fmtDate("19000101");
            this.birthSet.max = this.$util.fmtDate(birthmax);
            this.isPwdCheck = this.$cache.getPwdCheck("B1");
            // 初始化数据字典值
            this.annualincomes = this.$cache.getDict("150062");
            this.incomesources = this.$cache.getDict("150084");
            this.debts = this.$cache.getDict("150066");
            this.investmentedus = this.$cache.getDict("150067");
            this.investmentworks = this.$cache.getDict("150068");
            this.investmentexps = this.$cache.getDict("150069");
            this.investmentterms = this.$cache.getDict("150071");
            this.investfundtypes = this.$cache.getDict("150072");
            this.exceptedearnings = this.$cache.getDict("150074");
            this.affordableloss = this.$cache.getDict("150075");
            this.getCollectionInfo();
        },
        methods: {
            initUsefullife(){
                this.usefullifeObj["country"] = this.acctInfo["usefullifecountry"];
                this.usefullifeObj["province"] = this.acctInfo["usefullifeprovince"];
                this.usefullifeObj["city"] = this.acctInfo["usefullifecity"];
                this.usefullifeObj["county"] = this.acctInfo["usefullifecounty"];
            },
            getUsefullife(data){
                this.acctInfo.usefullife = data.address;
                if (data.country !== "CN") {
                    this.usefullifeObj["province"] = "";
                    this.usefullifeObj["city"] = "";
                    this.usefullifeObj["county"] = "";
                }
            },
            setUsefullife() {
                this.acctInfo["usefullifecountry"] = this.usefullifeObj["country"];
                this.acctInfo["usefullifeprovince"] = this.usefullifeObj["province"];
                this.acctInfo["usefullifecity"] = this.usefullifeObj["city"];
                this.acctInfo["usefullifecounty"] = this.usefullifeObj["county"];
            },
            checkUsefullifeInfo(){
                let hasLivingAddrInfo = true;
                if(this.acctInfo.usefullifecountry === "CN"){
                    hasLivingAddrInfo = !!this.acctInfo.usefullifeprovince && !!this.acctInfo.usefullife && !!this.acctInfo.usefullifecity;
                }else{
                    hasLivingAddrInfo = !!this.acctInfo.usefullife;
                }
                if(!hasLivingAddrInfo || this.$util.isEmpty(this.acctInfo.usefullifecountry)){
                    this.$alert("请完善注册地址(国家/地区-省-市-县)信息！","提示");
                    return false;
                }
                return true;
            },
            dateBirth (val) {
                this.acctInfo.instreprbirthday = val !== null ? val.replace(/-/g, "") : "";
            },
            /* 提交表单数据，校验用户信息 */
            submitInfo (formName) {
                const _this = this;
                _this.setUsefullife();
                _this.checkacctInfo.pwd = _this.acctInfo.pwd;
                if(!this.checkUsefullifeInfo()){
                    return;
                }
                if(JSON.stringify(_this.checkacctInfo) == JSON.stringify(_this.acctInfo)) {
                    _this.$message({
                        type: "info",
                        message: "表单数据未改变，请勿重复提交"
                    });
                    return;
                }
                _this.$refs[formName].validate(valid => {
                    if (valid) {
                        // 数据合并提交

                        if (_this.acctInfo.investfundtypeArr.length && _this.acctInfo.investfundtypeArr.length > 0) {
                            _this.acctInfo.investfundtype = _this.acctInfo.investfundtypeArr.join(",");
                        } else {
                            _this.acctInfo.investfundtype = "";
                        }
                        if (_this.acctInfo.actualctrlname !== "本机构") {
                            _this.acctInfo.actualctrlname = _this.acctInfo.actualctrlnameText;
                        }
                        if (_this.acctInfo.beneficiary !== "本机构") {
                            _this.acctInfo.beneficiary = _this.acctInfo.beneficiaryText;
                        }
                        let _x = Object.assign({}, _this.acctInfo);
                        if (_x.cerditrecord !== "1") {
                            _x.cerditrecord = _x.creditText;
                        }
                        _x.tradepwd = this.$util.enc(_x.pwd);
                        delete _x.investfundtypeArr;
                        delete _x.pwd;
                        delete _x.certificateno;
                        _this.$util.request("acct/orgcust/profile", _x, "PUT").then(res => {
                            if (res.data) {
                                const info = _this.$cache.getUser();
                                _this.$store.dispatch("setInfo", info).then(() => {
                                    _this.$cache.refreshUser();
                                    _this.$message({
                                        type: "success",
                                        message: "投资者信息补录已更新成功" + (_this.fn ? "" : "，3秒后回到信息中心页面"),
                                        onClose: function () {
                                            if (_this.fn) { _this.$emit("fn-back", true); } else {
                                                _this.$router.push({ name: "orginfo" });
                                            }
                                        }
                                    });
                                });
                            }
                        });
                    } else {
                        return false;
                    }
                });
            },
            actNameRequired (rule, value, callback) {
                if (this.$util.isEmpty(this.acctInfo.actualctrlnameText) && value === "其他") {
                    callback(new Error(rule.message));
                }else {
                    callback();
                }
            },
            benNameRequired (rule, value, callback) {
                if (this.$util.isEmpty(this.acctInfo.beneficiaryText) && value === "其他") {
                    callback(new Error(rule.message));
                }else {
                    callback();
                }
            },
            // 文字字母校验
            paramRequired (rule, value, callback) {
                if (rule.field === "cerditrecord") {
                    if (this.acctInfo.cerditrecord !== "1") {
                        this.$util.validateGeneral(rule, this.acctInfo["creditText"], callback, rule.mes);
                    }else {
                        callback();
                    }
                }else {
                    if (this.riskLock.indexOf(rule.field) === -1 && (this.required || value.trim() !== "")) {
                        this.$util.validateGeneral(rule, value, callback, rule.mes);
                    } else {
                        callback();
                    }
                }
            },
            // 资产校验
            assetsRequired (rule, value, callback) {
                if (this.riskLock.indexOf(rule.field) === -1 && (this.required || value.trim() !== "")) {
                    this.$util.validateDecimal(rule, value, callback);
                } else {
                    callback();
                }
            },
            selRequired (rule, value, callback) {
                if (this.riskLock.indexOf(rule.field) === -1 && (rule.field === "investfundtypeArr" && value.length === 0)) {
                    callback(new Error("请选择" + rule.mes));
                } else {
                    callback();
                }
            },
            getCollectionInfo () {
                const _this = this;
                this.$util.request("orgacct/orgGetAcctInfo").then(res => {
                    if (res.data) {
                        const _a = res.data[0];
                        _this.riskLock = _a.fromriskfield||[];
                        for (let item in _a) {
                            _a[item] = _a[item].trim();
                        }
                        if (_a.cerditrecord !== "1") {
                            _a.creditText = _a.cerditrecord;
                            _a.cerditrecord = "2";
                        }else {
                            _a.creditText = ""
                        }
                        if (_a.investfundtype.indexOf(",") > -1) {
                            _a.investfundtypeArr = _a.investfundtype.split(",");
                        } else {
                            _a.investfundtypeArr = [];
                            if (_a.investfundtype) {
                                _a.investfundtypeArr.push(_a.investfundtype);
                            }
                        }
                        if(_a.instreprbirthday){
                            this.birthSet.val = this.$util.fmtDate(_a.instreprbirthday);

                        }
                        if (_a.actualctrlname !== "本机构") {
                            _a.actualctrlnameText = _a.actualctrlname;
                            _a.actualctrlname = _a.actualctrlname ? "其他" : "本机构";
                        }
                        if (_a.beneficiary !== "本机构") {
                            _a.beneficiaryText = _a.beneficiary;
                            _a.beneficiary = _a.beneficiary ? "其他" : "本机构";
                        }
                        _this.acctInfo = Object.assign({}, _a || {});
                        _this.checkacctInfo = Object.assign({}, _a || {});
                        _this.initUsefullife();
                    }
                });
            },
            mustNum (val, param) {
                const _x = this.$util.filterNum(val);
                this.$set(this.acctInfo, param, _x);
            }
        }
    };
</script>
<style lang="scss">
    .comp-inv-info {
    .el-col.el-col-12 {
        height: 51px;
        overflow: hidden;
    }
    .acct-box {
        padding: 20px 10px;
    .el-select {
        width: 79%;
    .el-input {
        width: 100%;
    }
    }
    .el-input,
    .el-textarea {
        width: 79%;
    }
    .person-sel {
    .el-radio + .el-radio {
        margin-left: 20px;
    }
    .el-input {
        width: 40%;
        margin-left: 10px;
    }
    }
    }
    }
</style>
